//
//
//
//
//
//
//
//
//

import { loadGoogleMapsApi } from '@/utils/google/googleMapsLoader';

export default {
  name: 'GoogleMap',
  props: {
    apiKey: {
      type: String,
      required: true
    },
    initialCenter: {
      type: Object,
      default: () => ({ lng: 120.603599, lat: 24.191743 })
    },
    initialZoom: {
      type: Number,
      default: 12
    }
  },
  data() {
    return {
      map: null,
      google: null,
      marker: null,
      markerPosition: null,
      // markers: [],
      // searchQuery: '',
      // searchResults: [],
      // placesService: null,
      currentCenter: { ...this.initialCenter }
    };
  },
  async mounted() {
    try {
      // 加載Google Maps API，包含places庫
      this.google = await loadGoogleMapsApi(this.apiKey, ['places']);
      this.initMap();
    } catch (error) {
      console.error('Error loading Google Maps API:', error);
      this.$emit('error', error);
    }
  },
  methods: {
    initMap() {
      this.map = new this.google.maps.Map(this.$refs.map, {
        center: this.initialCenter,
        zoom: this.initialZoom,
        mapTypeControl: true,
        streetViewControl: true,
        fullscreenControl: true,
        styles: [
          {
            featureType: "poi",
            stylers: [{ visibility: "off" }]
          }
        ]
      });

      this.map.addListener('click', (event) => {
        this.placeMarker(event.latLng);
      });

      if (this.marker) {
        this.marker.setMap(null);
        this.marker = null;
      }
      this.markerPosition = null;
    },
    placeMarker(location) {
      // 移除現有標記
      if (this.marker) {
        this.marker.setMap(null);
      }

      // 創建新標記
      this.marker = new google.maps.Marker({
        position: location,
        map: this.map,
        draggable: true,
        animation: google.maps.Animation.DROP,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 10,
          fillColor: "#ea4335",
          fillOpacity: 1,
          strokeColor: "#ffffff",
          strokeWeight: 2
        }
      });

      // 保存位置
      this.markerPosition = {
        lat: location.lat(),
        lng: location.lng()
      };

      // 添加標記拖拽事件
      this.marker.addListener('dragend', (event) => {
        this.markerPosition = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng()
        };
      });

      // 將地圖中心移動到標記位置
      this.map.panTo(location);

      this.$emit('positionChange', this.markerPosition);
    },


    // initMap() {
    //   this.map = new this.google.maps.Map(this.$refs.map, {
    //     center: this.initialCenter,
    //     zoom: this.initialZoom,
    //     mapTypeControl: true,
    //     streetViewControl: true,
    //     fullscreenControl: true,
    //     styles: [
    //       {
    //         featureType: "poi",
    //         stylers: [{ visibility: "off" }]
    //       }
    //     ]
    //   });

    //   // 初始化地點服務
    //   this.placesService = new this.google.maps.places.PlacesService(this.map);

    //   // 監聽地圖中心變化
    //   this.map.addListener('center_changed', () => {
    //     const center = this.map.getCenter();
    //     this.currentCenter = {
    //       lat: center.lat(),
    //       lng: center.lng()
    //     };
    //   });

    //   // 添加初始標記
    //   this.addMarker(this.initialCenter);
    // },

    // addMarker(position = null) {
    //   if (!position) {
    //     // 在地圖中心添加標記
    //     position = this.map.getCenter();
    //   }

    //   const marker = new this.google.maps.Marker({
    //     position,
    //     map: this.map,
    //     title: `標記 ${this.markers.length + 1}`,
    //     draggable: true
    //   });

    //   // 添加資訊窗口
    //   const infoWindow = new this.google.maps.InfoWindow({
    //     content: `<div class="info-window">
    //         <h3>標記 ${this.markers.length + 1}</h3>
    //         <p>經度: ${position.lng.toFixed(6)}</p>
    //         <p>緯度: ${position.lat.toFixed(6)}</p>
    //       </div>`
    //   });

    //   marker.addListener('click', () => {
    //     infoWindow.open(this.map, marker);
    //   });

    //   this.markers.push(marker);
    // },

    // clearMarkers() {
    //   this.markers.forEach(marker => marker.setMap(null));
    //   this.markers = [];
    // },

    // centerMap() {
    //   this.map.setCenter(this.initialCenter);
    //   this.map.setZoom(this.initialZoom);
    // },

    // searchPlace() {
    //   if (!this.searchQuery.trim()) return;

    //   const request = {
    //     query: this.searchQuery,
    //     fields: ['name', 'geometry', 'formatted_address'],
    //     location: this.map.getCenter(),
    //     radius: 50000 // 50公裏半徑
    //   };

    //   this.placesService.textSearch(request, (results, status) => {
    //     if (status === this.google.maps.places.PlacesServiceStatus.OK) {
    //       this.searchResults = results.slice(0, 5);
    //     } else {
    //       this.searchResults = [];
    //       console.error('Places search failed:', status);
    //     }
    //   });
    // },

    // selectPlace(place) {
    //   this.searchResults = [];
    //   this.searchQuery = place.name;

    //   //移動地圖到選擇地點
    //   this.map.setCenter(place.geometry.location);
    //   this.map.setZoom(15);

    //   // 添加標記
    //   this.addMarker(place.geometry.location);
    // }
  }
};
